<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 搜索框 -->
		<div class="titleView">
			<div style="display: flex;align-items: center;margin-right: 10px;">
				<el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput" clearable size="small"/>
				<el-button type="warning" style="margin-left: 10px;" @click="getTableData" size="small">搜索</el-button>
			</div>
			<div class="flex">
				<div class="m-r-10">线上分类</div>
				<el-select v-model="categoryId" placeholder="请选择" class="titleSelect" @change="getTableData" size="small">
					<el-option v-for="item in classOptions" :key="item._id" :label="item.name" :value="item._id" />
				</el-select>
			</div>
			<div class="flex">
				<div class="m-r-10">上架状态</div>
				<el-select v-model="status" placeholder="请选择" class="titleSelect" @change="getTableData" size="small">
					<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</div>
			<div style="flex: 1;text-align: right;">
				<el-button type="warning" class="addClick" @click="handleResetClick" size="small">重置</el-button>
				<el-button class="addClick" @click="handleAddClick" size="small">添加商品</el-button>
			</div>
		</div>
		<!-- 表格 -->
		<div class="tableView" :style="{height:fixedHeight-82+'px'}">
			<el-table :data="tableData" size="small">
				<el-table-column prop="title" label="名称" :key="1" align="center">
				</el-table-column>
				<el-table-column prop="category_info.name" label="类型" :key="2" align="center">
				</el-table-column>
				<el-table-column prop="brand_name" label="品牌" :key="3" align="center" width="60">
				</el-table-column>
				<el-table-column prop="online_name" label="线上名称" :key="5" align="center">
				</el-table-column>
				<el-table-column prop="online_category_info" label="线上分类" :key="6" align="center" width="80">
					<template slot-scope="scope">
						{{scope.row.online_category_info == null?'--':scope.row.online_category_info.name}}
					</template>
				</el-table-column>
				<el-table-column prop="exprice_time" label="线上库存" :key="8" align="center" width="80">
					<template slot-scope="scope">
						{{scope.row.sku_extend_info[0].online_stock}}
					</template>
				</el-table-column>
				<el-table-column prop="exprice_time" label="线上售价" :key="9" align="center">
					<template slot-scope="scope">
						{{scope.row.sku_extend_info[0].online_sale_price}}
					</template>
				</el-table-column>
				<el-table-column prop="exprice_time" label="状态" :key="10" align="center" width="80">
					<template slot-scope="scope">
						<div v-if="scope.row.app_shelves == 0">编辑中</div>
						<div v-if="scope.row.app_shelves == 1">已上架</div>
						<div v-if="scope.row.app_shelves == -1">已下架</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" :key="11" align="center" width="120">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click='uploadImg(scope.row._id)'>编辑</el-button>
						<el-button type="text" size="small" @click="handelStartEndClick(scope.row,-1)" v-if="scope.row.app_shelves != 0 && scope.row.app_shelves == 1">下架</el-button>
						<el-button type="text" size="small" @click="handelStartEndClick(scope.row,1)" v-if="scope.row.app_shelves != 0 && scope.row.app_shelves == -1">上架</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :total="page.total" :pageSize='page.pageSize' @change="changePage" style="padding: 10px 0;"></page>
		</div>
		<!-- 添加商品弹框 -->
		<div v-if="dialogAddShop_state">
			<dialogAddShop @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" @submit="selectShop" :tree.sync="tree"></dialogAddShop>
		</div>
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import {
		getClass,
		onlineGoods,
		onlineAddGoods,
		appShelves
	} from '../../../api/program.js'
	import dialogAddShop from "../../../components/dialog_addShop.vue"
	export default{
		components: {
			page,
			dialogAddShop
		},
		data() {
			return{
				page: {
					page: 1,
					pageSize: 12,
					total: 0
				},
				tableData: [], //表格数据
				keyword:'', //关键字
				categoryId:'',  //线上分类
				status:99,  //上架状态
				classOptions: [], //线上分类列表
				statusOptions:[{
					value:99,
					label:'全部'
				},{
					value:0,
					label:'编辑中'
				},{
					value:1,
					label:'已上架'
				},{
					value:-1,
					label:'已下架'
				}],
				dialogAddShop_state:false,  //新增商品弹框状态
				tree :[{    //显示所需要类目
					id: "602f1e89c904d9db7ccf3c03"   //商品
				},{
					id: "602f1e88c904d9db7ccf3bec",  //医疗
				},{
					id: "60210f916e6d952a3929f0eb",  //虚拟
					children:[{
						id:"60210f916e6d952a3929f0ec"
					}]
				}],
				fixedHeight:''
			}
		},
		mounted() {
			this.getClassData()
			this.getTableData()
		},
		created(){
			this.fixedHeight = document.documentElement.clientHeight - 86;
		},
		methods:{
			//上下架
			handelStartEndClick(row,status){
				let that = this;
				let params = {
					id:row._id,
					status:status
				}
				appShelves(params).then((res)=>{
					if(res.code == 0){
						if(status == 1){
							this.$message({
								message: '已上架',
								type: 'success'
							});
							that.getTableData()
						}else if(status == -1){
							this.$message({
								message: '已下架',
								type: 'error'
							});
							that.getTableData()
						}
						console.log(res)
					}
				})
			},
			// 跳转上传
			uploadImg(id){
				this.$router.push({
					path:'upload',
					query:{
						id:id
					}
				})
			},
			//选中商品
			selectShop(val){
				console.log('已选中商品',val)
				let that = this;
				let shopObj = {
					param_type_id:val.goodsType
				}
				if(val.goodsType == 0){   //商品类目
					shopObj.param_type_name = '商品';   //类型名字
					shopObj.id = val.goodsItem.goodsId;   //商品id
					shopObj.name = val.goodsItem.title;  //商品名字
					shopObj.param_sku_id = val.skuItem._id;  //规格id
					shopObj.param_sku_name = val.skuItem.skus_name;  //规格
					shopObj.param_packing_way_id = val.wayItem.packing_way_id;  //包装方式id
					shopObj.param_packing_way_name = val.wayItem.packing_way_name;  //包装方式名称
				}else if(val.goodsType == 6){  //虚拟卡
					shopObj.param_type_name = '卡';   //类型名字
					shopObj.id = val.goodsItem.virtualId;   //商品id
					shopObj.name = val.goodsItem.title;  //商品名字
					shopObj.param_sku_id = val.skuItem.detail_id;  //规格id
					shopObj.param_sku_name = val.skuItem.service_objectName;  //规格
					shopObj.param_packing_way_id = '';  //包装方式id
					shopObj.param_packing_way_name = '';  //包装方式名称
				}else if(val.goodsType == 1){  //医疗
					shopObj.param_type_name = '医疗';   //类型名字
					shopObj.id = val.goodsItem.medical_id;   //商品id
					shopObj.name = val.goodsItem.title;  //商品名字
					shopObj.param_sku_id = '';  //规格id
					shopObj.param_sku_name = '';  //规格
					shopObj.param_packing_way_id = '';  //包装方式id
					shopObj.param_packing_way_name = '';  //包装方式名称
				}
				console.log('整合后商品',shopObj)
				let params = {
					productId:shopObj.id,
					skuId:shopObj.param_sku_id,
					unitId:shopObj.param_packing_way_id
				}
				onlineAddGoods(params).then((res)=>{
					if(res.code == 0){
						console.log(res)
						this.$message({
							message: '已添加商品',
							type: 'success'
						});
						that.getTableData()
					}
				})
			},
			//添加商品
			handleAddClick(){
				this.dialogAddShop_state = true;
			},
			//获取表格
			getTableData(){
				let params = {
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
					keyword:this.keyword,
					categoryId:this.categoryId,
					status:this.status
				}
				onlineGoods(params).then((res)=>{
					if(res.code == 0){
						console.log(res.data)
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//重置
			handleResetClick(){
				this.page.page = 1;
				this.status = 99;
				this.keyword = '';
				this.categoryId = '';
				this.getTableData()
			},
			//获取类别
			getClassData() {
				let params = {
					'pageIndex': 0,
					'pageSize': 0,
					'type': '商城分类',
					'class': '线上'
				}
				getClass(params).then((res) => {
					if (res.code == 0) {
						console.log('获取类别', res.data)
						this.classOptions = res.data.data
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.titleView {
		height: 72px;
		line-height: 72px;
		display: flex;
		background: #fff;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;
		padding: 0 10px;
		font-size: 14px;
		.titleInput {
			width: 160px;
		}
	
		.titleDate {
			width: 224px;
		}
	
		.titleSelect {
			width: 100px;
		}
	}
	
	.flex {
		display: flex;
		align-items: center;
		margin-right: 10px;
	}
	
	.m-r-10 {
		margin-right: 10px;
	}
	.tableView{
		background: #fff;
	}
</style>
